const headerMenu = document.querySelector(".header__inline-menu");
const headerIcons = document.querySelector(".header__icons");
const collectionMenu = document.querySelector(".collection-menu-wrapper");

const collectionWrapper = document.querySelector(
  ".main-collection-product-grid"
);
const collectionMenuTop = collectionWrapper.offsetTop;

let previousScrollPosition = window.pageYOffset;

window.addEventListener("scroll", () => {
  const currentScrollPosition = window.pageYOffset;

  /* if (currentScrollPosition > collectionMenuTop) {
    headerMenu.classList.add("hidden");
    headerIcons.classList.add("hidden");
    collectionMenu.style.zIndex = "10";
  } */

  if (currentScrollPosition < previousScrollPosition) {
    if (currentScrollPosition < collectionMenuTop) {
      headerMenu.classList.remove("hidden");
      headerIcons.classList.remove("hidden");
      collectionMenu.style.zIndex = "1";
    }
  }

  previousScrollPosition = currentScrollPosition;
});
